import { render, staticRenderFns } from "./EmailFailed.vue?vue&type=template&id=3633fce0&"
import script from "./EmailFailed.vue?vue&type=script&lang=js&"
export * from "./EmailFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmailFailed.vue"
export default component.exports